export default __webpack_public_path__ + "static/media/landscape1.ddaef5ed.jpeg";